import type { DatovkaApiType } from '@gov-nx/api';
import { useRecipientSearchAutocomplete } from '@gov-nx/core/hooks';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';
import { FormAutocomplete } from '@gov-nx/ui/web';
import { DataBoxListItem } from './DataBoxListItem';

export const RecipientAutocomplete = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);
	const { searchCallback } = useRecipientSearchAutocomplete();

	const getDataBoxListItem = (dataBox: DatovkaApiType, searchValue: string) => (
		<DataBoxListItem
			dataBox={dataBox}
			searchValue={searchValue}
		/>
	);

	return (
		<div className="gov-form-control ds-new-message ds-recipient pr-0.5">
			<FormAutocomplete
				label={{
					children: `${tn('nova-zprava.komu')}:`,
					isRequired: true,
				}}
				field={{
					name: 'recipientAutocomplete',
					placeholder: tn('nova-zprava.vyhledejte'),
					messageEmpty: tn('nova-zprava.zadny-vysledek'),
					templateResolver: (item) => getDataBoxListItem(item, ''), // @TODO SMID: provide this second argument fom DS
					valueResolver: () => '',
					keyResolver: (item: DatovkaApiType) => item.datovaSchrankaId || '',
					searchCallback,
				}}
			/>
		</div>
	);
};
